import React, { memo } from 'react'

const IconAddNew = ({ color = "white", ...props }) => (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M0.75 6.00061H11.25M6 0.750488V11.2505" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default memo(IconAddNew);